// Inform Typescript about global function
declare function fbq(...args: any[]): void;

function isFbqLoaded(): boolean {
  return typeof fbq === 'function';
}

export function fbqPixelEvent(eventName: string): void {
  if (isFbqLoaded()) {
    fbq('track', eventName);
  }
}
